import React from "react";
import _get from "lodash/get";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import { withRouter } from "react-router-dom";
import { withStyles } from '@mui/styles';
import Dialog from '@mui/material/Dialog';
import DialogContent from '@mui/material/DialogContent';
import DialogTitle from '@mui/material/DialogTitle';
import IconButton from '@mui/material/IconButton';
import CloseIcon from "@mui/icons-material/Close";
import Typography from '@mui/material/Typography';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';

const styles = theme => ({
    DialogActions: {
        marginTop: 20
    },
    closeButton: {
        position: "absolute",
        right: theme.spacing(1),
        top: theme.spacing(1),
        color: theme.palette.grey[500]
    },
    wrapper: {
        padding: theme.spacing(1),
        minHeight: 200,
        overflow: "scroll"
    },
    driverTitle: {
        fontWeight: 500,
        fontSize: 14,
        marginTop: 10,
        display: "inline-block",
        minWidth: 175
    },
    driverContent: {
        fontSize: 14,
        marginTop: 10,
        display: "inline-block"
    }
});

export class RecapDialog extends React.Component {
    state = {
        successMessage: "",
        errorMessage: ""
    };

    componentDidMount() {
        this.getDriverRecap();
    }

    getDriverRecap = async () => {
        const payload = {
            days: 14,
            driverId: this.props.driverId,
            selectedDate: this.props.selectedDate
        };
        await this.props.getDriverDaily(payload);
    };

    render() {
        const { classes, recapBusy = false, driverDiary = {} } = this.props;

        return (
            <Dialog
                fullWidth={true}
                maxWidth={"md"}
                className={classes.wrapper}
                open={this.props.open}
                onClose={this.props.handleRecapClose}
                aria-labelledby="alert-dialog-title"
                aria-describedby="alert-dialog-description"
            >
                <DialogTitle
                    id="alert-dialog-title"
                    onClose={this.props.handleRecapClose}
                >
                    <Typography>
                        {recapBusy ? "LOADING..." : "RECAP"}
                    </Typography>
                    <IconButton
                        aria-label="Close"
                        className={classes.closeButton}
                        onClick={this.props.handleRecapClose}
                        sx={{
                          position: "absolute",
                          right: 8,
                          top: 8,
                        }}
                    >
                        <CloseIcon />
                    </IconButton>
                </DialogTitle>

                <DialogContent>
                    <Table className={classes.table}>
                        <TableHead>
                            <TableRow>
                                <TableCell>DATE</TableCell>
                                <TableCell>Driving</TableCell>
                                <TableCell>OffDuty</TableCell>
                                <TableCell>OnDutyND</TableCell>
                                <TableCell>Sleeper</TableCell>
                                {/*<TableCell>WaitingAtWellSite</TableCell>*/}
                            </TableRow>
                        </TableHead>
                        <TableBody>
                            {Array.isArray(driverDiary) &&
                                driverDiary.map((item, i) => (
                                    <TableRow key={i}>
                                        <TableCell>
                                            {this.props.formatRawDate(
                                                item.logDate
                                            )}
                                        </TableCell>
                                        <TableCell>
                                            {item.drivingHours}
                                        </TableCell>
                                        <TableCell>
                                            {item.offDutyHours}
                                        </TableCell>
                                        <TableCell>
                                            {item.onDutyNDHours}
                                        </TableCell>
                                        <TableCell>
                                            {item.sleeperHours}
                                        </TableCell>
                                        {/*<TableCell>
                                            {item.waitingAtWellSiteHours}
                                        </TableCell>*/}
                                    </TableRow>
                                ))}
                        </TableBody>
                    </Table>
                </DialogContent>
            </Dialog>
        );
    }
}

const mapStateToProps = state => {
    return {
        recapBusy: _get(state, "logData.recapBusy", false),
        driverDiary: _get(state, "logData.driverDiary", []),
        driverId: _get(state, "driverData.selectedDriver.driver.id", {})
    };
};

const mapDispatchToProps = dispatch => bindActionCreators({}, dispatch);

export default withStyles(styles)(
    withRouter(
        connect(
            mapStateToProps,
            mapDispatchToProps
        )(RecapDialog)
    )
);
